/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/nomosocialclub/"

const NOMOSOCIALCLUB: CommunityData = {
  code: "nomosocialclub",
  inviteCode: "nomosocialclub",
  name: "NoMo Social Club",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/nom-046`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#FFF",
      werzLogoColor: "#FFF",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[192px] h-[74px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[192px] h-[74px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#1e0035",
      asideBg: "#550099",
      asideStyles: "",
      contentBg: "#1e0035",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      nonMemberBg: `${S3_PREFIX}web-landing.png`,
      mainFont: "font-['BrandonTextRegular']",
      primaryButton:
        "bg-[#550099] border border-[#370063] rounded-[8px] px-[18px] py-[18px] gap-y-[6px] text-[#ffdcf1] font-['IntroRustBase'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#ffa1da]",
      separator: "border-[#ffa1da]",
      item: "font-['IntroRustBase'] text-[16px] text-[#ffffff] text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#ffa1da] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#1e0035] border border-[#ffa1da] rounded-[32px] !pb-8",
      titles: "text-[#ffffff] font-['IntroRustBase'] text-[28px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['BrandonTextRegular'] text-[15px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ffa1da]",
        sectionTitle:
          "text-[#ffffff] font-['IntroRustBase'] text-[28px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#1e0035]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative rounded-xl overflow-hidden",
          media: "w-full !aspect-square object-cover rounded-xl",
          placeholderMedia: "w-full !aspect-square bg-gray-400 rounded-xl",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#ffffff] font-['IntroRustBase'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#ffffff] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ffa1da]",
        sectionTitle:
          "text-[#ffffff] font-['IntroRustBase'] text-[28px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#1e0035] rounded-[16px]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 relative rounded-xl overflow-hidden",
          media: "w-full !aspect-video object-cover rounded-xl",
          placeholderMedia: "w-full !aspect-video bg-gray-400 rounded-xl",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#ffffff] font-['IntroRustBase'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#ffffff] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#ffffff] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#ffffff] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#ffffff] font-['IntroRustBase'] text-[26px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['BrandonTextRegular'] text-[17px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['IntroRustBase'] text-[28px] text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: `${S3_PREFIX}web-landing.png`,
      bgMobile: `${S3_PREFIX}mobile-landing-background.mov?type=video`,
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative bg-[#1e0035] px-4 py-12 sm:p-[64px]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] border-[#ffa1da] object-cover",
        name: "text-[#ffffff] font-['IntroRustBase'] text-[28px] text-center leading-[110%] mt-4 mb-1",
        location:
          "text-[#ffffff] font-['IntroRustBase'] text-[20px] text-center leading-[110%] mb-2",
        description:
          "text-[#ffffff] font-['BrandonTextRegular'] text-[17px] text-center leading-[120%] mb-4 max-w-[500px]",
        socialMediaIconColor: "#ffdcf1",
        button:
          "bg-[#1e0035] border border-[#ffa1da] rounded-[8px] px-[16px] py-[16px] text-[#ffdcf1] font-['IntroRustBase'] text-[14px] text-left leading-[100%] cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] bg-[#1e0035] text-[#ffffff] font-['BrandonTextRegular'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#ffa1da] rounded-[32px]",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] bg-[#1e0035] border border-[#ffa1da] rounded-[32px] flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title:
            "text-[#ffffff] font-['IntroRustBase'] text-[20px] text-center leading-[110%] mb-1",
          text: "text-[#ffffff] font-['BrandonTextRegular'] text-[17px] text-center leading-[120%]",
          button:
            "bg-[#1e0035] border border-[#ffa1da] rounded-[8px] px-[16px] py-[16px] text-[#ffdcf1] font-['IntroRustBase'] text-[14px] text-left leading-[100%] cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['IntroRustBase'] text-[20px] text-center leading-[110%] mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] bg-[#1e0035] border border-[#ffa1da] rounded-[16px] flex justify-between",
          duration:
            "text-[#ffffff] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%]",
          name: "text-[#ffffff] font-['IntroRustBase'] text-[20px] leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#ffdcf1",
          media: "border border-[#ffa1da] overflow-hidden rounded-[12px] m-2",
        },
        event: {
          container:
            "bg-[#1e0035] border border-[#ffa1da] rounded-[16px] overflow-hidden sm:w-[500px] w-[95vw]",
          name: "text-[#ffffff] font-['IntroRustBase'] text-[20px] text-left leading-[110%] mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] rounded-[12px] bg-[#000000] border border-[#bd1b79] text-[#ffffff] flex flex-col justify-center items-center gap-1 font-['IntroRustBase']",
          duration:
            "text-[#ffffff] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%]",
          location:
            "text-[#ffffff] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%]",
          button:
            "bg-[#1e0035] border border-[#ffa1da] rounded-[8px] px-[16px] py-[16px] text-[#ffdcf1] font-['IntroRustBase'] text-[14px] text-left leading-[100%] cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] border-t border-[#ffa1da] px-4 py-3 flex justify-between gap-4",
            name: "text-[#ffffff] font-['IntroRustBase'] text-[16px] text-left leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#ffffff] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%]",
            link: "text-[#ffffff] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%]",
            status: "text-[#ffffff] font-['IntroRustBase'] text-[16px] text-left leading-[110%]",
            button:
              "bg-[#1e0035] border border-[#ffa1da] rounded-[8px] px-[16px] py-[16px] text-[#ffdcf1] font-['IntroRustBase'] text-[14px] text-left leading-[100%] cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ffffff] font-['BrandonTextRegular'] text-[17px] text-center leading-[120%] mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] bg-[#1e0035] text-[#ffffff] font-['BrandonTextRegular'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#ffa1da] rounded-[32px]",
        header:
          "text-[#ffffff] font-['IntroRustBase'] text-[20px] text-center leading-[110%] mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer bg-[#1e0035] sm:w-[500px] w-[95vw] border border-[#ffa1da] rounded-[16px] flex justify-between",
          name: "text-[#ffffff] font-['IntroRustBase'] text-[20px] leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#ffdcf1",
          created:
            "text-[#ffffff] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%]",
          media: "border border-[#ffa1da] overflow-hidden rounded-[12px] m-2",
        },
        seeAllNews:
          "text-[#ffffff] font-['BrandonTextRegular'] text-[17px] text-center leading-[120%] mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] bg-[#1e0035] text-[#ffffff] font-['BrandonTextRegular'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#ffa1da] rounded-[32px]",
        header:
          "text-[#ffffff] font-['IntroRustBase'] text-[20px] text-center leading-[110%] mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer bg-[#1e0035] sm:w-[500px] w-[95vw] border border-[#ffa1da] rounded-[16px] flex justify-between",
          coverUrl: "border border-[#ffa1da] overflow-hidden rounded-[12px] m-2",
          duration:
            "text-[#ffffff] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%]",
          liveType:
            "text-[#ffdcf1] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%]",
          liveTypeCircle: "w-2 h-2 bg-[#ffdcf1] rounded-full",
          playIconColor: "#ffdcf1",
          start: "text-[#ffffff] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%]",
          title:
            "text-[#ffffff] font-['IntroRustBase'] text-[20px] leading-[110%] one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#ffffff] font-['BrandonTextRegular'] text-[17px] text-center leading-[120%] mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] bg-[#1e0035] text-[#ffffff] font-['BrandonTextRegular'] text-[17px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#ffa1da] rounded-[32px]",
        header:
          "text-[#ffffff] font-['IntroRustBase'] text-[20px] text-center leading-[110%] mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] bg-[#1e0035] w-[95vw] border border-[#ffa1da] rounded-[16px] flex justify-between",
          name: "text-[#ffffff] font-['IntroRustBase'] text-[20px] leading-[110%]",
          triangleIconColor: "#ffdcf1",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#ffa1da] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#ffffff] font-['BrandonTextRegular'] text-[11px] text-center leading-[120%]",
      },
    },
    shopV2: {
      container: "mb-16 sm:p-8 p-4 sm:pb-8 bg-[#1e0035] border border-[#ffa1da] rounded-[32px]",
      header: "text-[#ffffff] font-['IntroRustBase'] text-[28px] text-left leading-[110%]",
      emptyState: "text-[#ffdcf1] font-['BrandonTextRegular'] text-[15px] text-left",
      membershipSection: {
        container: "mb-8",
        header: "text-[#ffffff] font-['IntroRustBase'] text-[26px] text-left leading-[110%] mb-4",
        products: {
          container: "flex flex-col overflow-hidden",
          product: {
            container:
              "flex flex-row justify-between gap-4 leading-auto border-b border-[#ffa1da] py-4 mb-4",
            media: "!hidden",
            mediaContainer: "",
            name: "text-[#ffffff] font-['IntroRustBase'] text-[16px] text-left leading-[110%]",
            description:
              "text-[#ffdcf1] font-['BrandonTextRegular'] text-[15px] text-left leading-[120%] !mt-1",
            price:
              "text-[#ffdcf1] font-['IntroRustBase'] text-[16px] text-left leading-[110%] !mt-1",
            quantity: "text-[#ffdcf1] font-['IntroRustBase'] text-[14px] text-left leading-[100%]",
            status: "text-[#ffdcf1] font-['IntroRustBase'] text-[16px] text-left leading-[110%]",
            counterContainer:
              "bg-[#1e0035] border border-[#ffa1da] rounded-[8px] px-[16px] py-[16px] gap-x-[16px] !w-fit !h-10",
            plusMinusColor: "#ffdcf1",
            button:
              "bg-[#1e0035] border border-[#ffa1da] rounded-[8px] px-[16px] py-[16px] text-[#ffdcf1] font-['IntroRustBase'] text-[14px] text-left leading-[100%] !w-fit",
            descriptionCutoff: 50,
          },
        },
      },
      eventSection: {
        container: "mb-8",
        header: "text-[#ffffff] font-['IntroRustBase'] text-[26px] text-left leading-[110%] mb-4",
        event: {
          container: "flex items-start gap-4 mb-4",
          dateBox:
            "bg-[#550099] p-2 w-[52px] h-[52px] flex flex-col items-center justify-center text-center rounded-lg border border-[#370063]",
          month: "text-xs font-['IntroRustBase'] uppercase leading-[16px] text-[#ffdcf1]",
          day: "text-base font-['IntroRustBase'] uppercase leading-[16px] text-[#ffdcf1]",
          details: "flex-1",
          name: "text-[#ffffff] font-['IntroRustBase'] text-[16px] text-left leading-[110%]",
          date: "text-[#ffdcf1] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%] mt-1",
          location:
            "text-[#ffdcf1] font-['BrandonTextRegular'] text-[12px] text-left leading-[120%] mt-1",
        },
        tickets: {
          container: "flex flex-col overflow-hidden",
          ticket: {
            container:
              "flex flex-row justify-between gap-4 leading-auto border-b border-[#ffa1da] pb-2 mb-2",
            media: "!hidden",
            mediaContainer: "",
            name: "text-[#ffffff] font-['IntroRustBase'] text-[16px] text-left leading-[110%]",
            description:
              "text-[#ffdcf1] font-['BrandonTextRegular'] text-[15px] text-left leading-[120%] !mt-1",
            price:
              "text-[#ffdcf1] font-['IntroRustBase'] text-[16px] text-left leading-[110%] !mt-1",
            quantity: "text-[#ffdcf1] font-['IntroRustBase'] text-[14px] text-left leading-[100%]",
            status: "text-[#ffdcf1] font-['IntroRustBase'] text-[16px] text-left leading-[110%]",
            counterContainer:
              "bg-[#1e0035] border border-[#ffa1da] rounded-[8px] px-[16px] py-[16px] gap-x-[16px] !w-fit !h-10",
            plusMinusColor: "#ffdcf1",
            button:
              "bg-[#1e0035] border border-[#ffa1da] rounded-[8px] px-[16px] py-[16px] text-[#ffdcf1] font-['IntroRustBase'] text-[14px] text-left leading-[100%] !w-fit",
            descriptionCutoff: 50,
          },
        },
      },
      merchSection: {
        container: "mb-8",
        header: "text-[#ffffff] font-['IntroRustBase'] text-[26px] text-left leading-[110%] mb-4",
        products: {
          container: "grid grid-cols-3 gap-4",
          product: {
            container: "cursor-pointer",
            innerContainer: "flex flex-col",
            media: "w-full !aspect-square object-cover rounded-xl",
            mediaContainer: "w-full rounded-xl overflow-hidden",
            name: "text-[#ffffff] font-['IntroRustBase'] text-[16px] text-left leading-[110%] mt-3",
            description:
              "text-[#ffdcf1] font-['BrandonTextRegular'] text-[14px] text-left leading-[120%] !mt-1",
            price:
              "text-[#ffffff] font-['IntroRustBase'] text-[16px] text-left leading-[110%] !mt-2",
            quantity: "!hidden",
            status: "text-[#ffdcf1] font-['IntroRustBase'] text-[16px] text-left leading-[110%]",
            counterContainer: "!hidden",
            plusMinusColor: "#ffdcf1",
            button: "!hidden",
            descriptionCutoff: 50,
          },
        },
      },
    },
    shopProductV2: {
      container: "flex flex-col sm:p-8 p-4 bg-[#1e0035] border border-[#ffa1da] rounded-[32px]",
      media: "w-full sm:!h-[486px] object-cover rounded-xl",
      title: "text-[#ffffff] font-['IntroRustBase'] text-[28px] text-left leading-[110%] mt-6",
      additionalDetails:
        "text-[#ffffff] font-['BrandonTextRegular'] text-[15px] text-left leading-[120%] mt-4",
      priceSection: "border-t border-[#ffa1da] mt-6 pt-6",
      displayPrice: "text-[#ffffff] font-['IntroRustBase'] text-[26px] text-left leading-[110%]",
      shortTerms: "text-[#ffdcf1] font-['BrandonTextRegular'] text-[12px] text-left mt-2",
      variantSelector: {
        section: "mt-6 space-y-4 !hidden",
        separator: "flex items-center justify-between border-t border-[#ffa1da] pt-4",
        label: "text-sm font-['IntroRustBase'] text-[#ffffff]",
        sizeButton:
          "px-4 py-2 border border-[#ffa1da] bg-[#1e0035] text-[#ffdcf1] rounded-[8px] hover:border-[#ffffff] transition-all font-['IntroRustBase']",
        sizeButtonSelected:
          "px-4 py-2 border border-[#550099] bg-[#550099] text-[#ffdcf1] rounded-[8px] font-['IntroRustBase']",
        sizeButtonOneSize:
          "px-4 py-2 border border-[#550099] bg-[#550099] text-[#ffdcf1] rounded-[8px] cursor-default font-['IntroRustBase']",
        colorSwatchContainer: "flex gap-3 items-center",
        colorSwatch:
          "w-10 h-10 rounded-full border-4 border-[#ffa1da] hover:border-[#ffffff] transition-all",
        colorSwatchSelected:
          "w-10 h-10 rounded-full border-4 border-[#550099] scale-110 transition-all",
        validationMessage:
          "text-[#ffdcf1] font-['BrandonTextRegular'] text-sm mt-2 border-t border-[#ffa1da] pt-4",
      },
      counter: {
        container: "flex items-center gap-4 border border-[#ffa1da] rounded-[8px] px-4 py-3",
        quantity: "text-lg font-['IntroRustBase'] text-[#ffffff] min-w-[20px] text-center",
        plusMinusColor: "#ffdcf1",
      },
      button:
        "bg-[#550099] border border-[#370063] rounded-[8px] px-[18px] py-[18px] text-[#ffdcf1] font-['IntroRustBase'] !text-[16px] text-left leading-[100%] !w-fit self-center",
    },
    eventV2: {
      container: "flex flex-col !bg-[#1e0035] border border-[#ffa1da] rounded-[32px] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#ffa1da]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0 rounded-xl",
        title: "text-[#ffffff] font-['IntroRustBase'] text-[28px] text-left leading-[110%]",
        subtitle:
          "text-[#ffffff] font-['BrandonTextRegular'] text-[15px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#550099] border border-[#370063] rounded-[8px] px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#ffdcf1] font-['IntroRustBase'] !text-[16px] text-left leading-[100%]",
        questions: "text-[15px] text-left leading-[120%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#ffa1da]",
        header: "text-[#ffffff] font-['IntroRustBase'] text-[26px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['BrandonTextRegular'] text-[15px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#ffa1da]",
        header: "text-[#ffffff] font-['IntroRustBase'] text-[26px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['BrandonTextRegular'] text-[15px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden rounded-xl gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#ffffff] font-['IntroRustBase'] text-[26px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['BrandonTextRegular'] text-[15px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['IntroRustBase'] text-[26px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#1e0035] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#1e0035] border border-[#ffa1da] rounded-[8px] px-[16px] py-[16px] text-[#ffdcf1] font-['IntroRustBase'] text-[14px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#1e0035] border-b border-[#ffa1da] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['IntroRustBase'] text-[16px] text-left leading-[110%] mb-1",
          description:
            "text-[#ffffff] font-['BrandonTextRegular'] text-[15px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#ffffff] font-['IntroRustBase'] text-[16px] text-left leading-[110%]",
          quantity: "text-[#ffdcf1] font-['IntroRustBase'] text-[14px] text-left leading-[100%]",
          status: "text-[#ffffff] font-['IntroRustBase'] text-[16px] text-left leading-[110%]",
          counterContainer:
            "bg-[#1e0035] border border-[#ffa1da] rounded-[8px] px-[16px] py-[16px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#1e0035] border border-[#ffa1da] rounded-[8px] px-[16px] py-[16px] text-[#ffdcf1] font-['IntroRustBase'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#ffdcf1",
        },
      },
    },
  },
}

export default NOMOSOCIALCLUB
